<script>
export default {
    name: "description-setting",
    props: {
        elementDurationDisabled: Boolean,
        innerDurationElement: String,
        disabled: Boolean,
        value: {}
    },
    data() {
        return {
            currentValue: undefined,
            timeout: null,
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal !== this.currentValue) {
                    this.currentValue = newVal;
                }
            },
            immediate: true
        }
    },
    computed: {
        label() {
            return Lang.langGet("Description / Comment");
        }
    },
    methods: {
        handleChange(val) {
            this.currentValue = val;
            this.scheduleUpdate();
        },
        scheduleUpdate() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.updateDescription, 500);
        },
        updateDescription() {
            clearTimeout(this.timeout);
            this.$emit('input', this.currentValue);
        }
    },
    beforeDestroy() {
        clearTimeout(this.timeout);
    }
}
</script>

<template>
    <v-text-field
        :value="currentValue"
        :label="label"
        :disabled="disabled"
        outlined
        dense
        hide-details="auto"
        @input="handleChange"
        @keydown.enter="scheduleUpdate"
        @blur="updateDescription"
    />
</template>

